<ds-checkbox
    [checkboxInput]="checkboxConfig"
    (checkedChange)="onClick($event)">
</ds-checkbox>